
import { Handle, Position } from 'reactflow';

// This is being used for the intermediate flows and NOT THE MAIN FLOW!!!

export default function StopNode({ data }) {

    return (
        <>
            <div className='bg-[#ebad25] text-white rounded-xl p-2 px-4'>
                <span>{data.name}</span>
            </div>
            <Handle type="target" position={Position.Left} id="stop" />
        </>
    );
}